import Subsription from './Subscription'
import { notAuthorized } from '../database/Text'
import { useMainContext } from '../callContext/MainContext'

const NotAllowed = () => {
  const {language}=useMainContext();
  return (
    <Subsription>
         <p className='px-4 pb-4 tracking-wider'>{notAuthorized?.[language]}</p>
    </Subsription>
  )
}

export default NotAllowed